import { combineReducers } from 'redux';
import {
  CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK,
  CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES,
  CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY,
  CUSTOMERS_FEEDBACK_SET_RECEIPT,
  CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE,
  CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE,
} from 'actions/customers/feedback/constants';
import createReducer from 'utils/createReducer';

const feedbacks = createReducer(
  {
    results: [],
    total_count: 0,
    total_pages: 0,
  },
  {
    [CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK]: (draft, { payload }) =>
      payload.feedbacks,
  }
);

const feedbackMessages = createReducer(
  {
    business_logo_url: '',
    business_name: '',
    customer_email: '',
    customer_name: '',
    messages: [],
  },
  {
    [CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES]: (draft, { payload }) =>
      payload.feedbackMessages,
  }
);

const feedbackData = createReducer(
  {
    comment: '',
    feedback_id: 0,
  },
  {
    [CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY]: (draft, { payload }) =>
      payload.feedbackData,
  }
);

const transactionDetail = createReducer(null, {
  [CUSTOMERS_FEEDBACK_SET_RECEIPT]: (draft, { payload }) =>
    payload.transactionDetail,
});

const currentPage = createReducer(null, {
  [CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

// FIXME wrong default type
const totalPage = createReducer(null, {
  [CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

export default combineReducers({
  feedbacks,
  feedbackMessages,
  feedbackData,
  transactionDetail,
  currentPage,
  totalPage,
});
